import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Badge } from 'softcat:components/badge.tsx';
import { BadgeState } from 'softcat:config/badge-state.ts';

type CertificateStatusProperties = {
    certificateExpiry?: string;
    showText?: boolean;
};

export const CertificateStatus: FunctionComponent<CertificateStatusProperties> = ({ certificateExpiry, showText = true }) => {
    const expiryDate = new Date(certificateExpiry || '');

    if (Number.isNaN(expiryDate.valueOf())) {
        return showText ? <FormattedMessage id={'CERTIFICATE_NO_CERTIFICATE'} /> : '';
    }

    const today = Date.now();
    const expiryDatetime = expiryDate.getTime();
    // 90 days = 7776000000 milliseconds
    const expiryWarningTime = today + 7_776_000_000;
    const isExpired = expiryDatetime < today;
    const isExpiring = expiryDatetime < expiryWarningTime;

    let status = BadgeState.VALID;
    let statusText = 'CERTIFICATE_STATUS_VALID';

    if (isExpired) {
        status = BadgeState.ERROR;
        statusText = 'CERTIFICATE_STATUS_EXPIRED';
    } else if (isExpiring) {
        status = BadgeState.WARNING;
        statusText = 'CERTIFICATE_STATUS_EXPIRING';
    }

    return (
        <span title={`${expiryDate.toDateString()}`}>
            <Badge status={status}>
                {showText && (
                    <>
                        <FormattedMessage id={statusText} /> {expiryDate.toDateString()}
                    </>
                )}
            </Badge>
        </span>
    );
};
